import styled from "styled-components";
import { DynamicModal } from "@/shared/components";
import { Icon } from "@/shared/components/Icon";
import type { CreatorInvitationUnavailableState } from "../../hooks/useCreatorInvitation";
import {
	getCreatorInvitationUnavailableAction,
	getCreatorInvitationUnavailableCopy,
} from "../../utils/creatorInvitationUnavailable";

// Spacing mirrors the public CreatorInvitationUnavailable card (Figma 8246:52987):
// 24px badge→title, 16px title→body, 28px body→CTA, on top of DynamicModal's
// 16px header gap, 8px title→description and 16px description→actions.
const Badge = styled.div`
	display: grid;
	place-items: center;
	width: 44px;
	height: 44px;
	margin-bottom: 8px;
	border-radius: 8px;
	background: rgb(216 0 39 / 11%);
	color: #d80027;
`;

// The dialog's content box is 456px, just enough for the longest title on one
// line; below 568px viewports the dialog shrinks and the title must wrap.
const Title = styled.span`
	display: block;
	color: #303030;
	line-height: 1.3;
	white-space: nowrap;

	@media (max-width: 568px) {
		white-space: normal;
	}
`;

const Body = styled.span`
	display: block;
	margin: 8px 0 12px;
	color: #454545;
	font-size: 16px;
	line-height: 1.55;
`;

export const CreatorInvitationUnavailableDialog = ({
	open,
	state,
	onClose,
}: {
	open: boolean;
	state: CreatorInvitationUnavailableState | null;
	onClose: () => void;
}) => {
	if (!state) return null;
	const copy = getCreatorInvitationUnavailableCopy(state);
	const action = getCreatorInvitationUnavailableAction(state);

	return (
		<DynamicModal
			open={open}
			onCancel={onClose}
			icon={
				<Badge>
					<Icon name="xCircle" size={24} aria-hidden="true" preserveOriginalColor />
				</Badge>
			}
			title={<Title>{copy.title}</Title>}
			description={<Body>{copy.body}</Body>}
			confirmText={action.label}
			confirmHref={action.href === "/" ? undefined : action.href}
			onConfirm={onClose}
			width={520}
			centered
			singlePrimaryAction
			actionHeight={56}
			showCloseButton={false}
		/>
	);
};
